import { Card } from 'antd';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import Header from './components/Header';
import Table from './components/Table';

const List = () => {
  const { t } = useTranslation();
  return (
    <>
      <Helmet title={`Kvalilog > ${t('pages.admin.pumps')}`} />
      <Card bordered={false} title={<Header />}>
        <Table />
      </Card>
    </>
  );
};

export default List;
